import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Paths, TITLE_MAP } from '@/router/constants';

const getPageTitle = (pathname: string): string => {
    if (pathname.startsWith(Paths.JOBS) || pathname.startsWith(Paths.TASKS)) {
        return TITLE_MAP.INSPECTOR;
    }

    return TITLE_MAP.DEFAULT;
};

export function useDocumentTitle(): void {
    const location = useLocation();

    useEffect(() => {
        const title = getPageTitle(location.pathname);
        document.title = title;
    }, [location.pathname]);
}
